import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import EraArchive from "./components/EraArchive";
import Featured from "./components/Featured";
import RarePicks from "./components/RarePicks";
import Story from "./components/Story";
import Faq from "./components/Faq";
import About from "./components/About";
import Contribute from "./components/Contribute";
import Footer from "./components/Footer";

const pageLd = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  name: "073漫画网 - 老漫画补档列表",
  description: "老漫画按年代归档，经典老番与绝版资源补档列表。",
  url: "https://oldcomic.github.io/",
  breadcrumb: {
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "首页", item: "https://oldcomic.github.io/" },
      {
        "@type": "ListItem",
        position: 2,
        name: "老漫画补档",
        item: "https://oldcomic.github.io/#classics",
      },
    ],
  },
};

function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!show) return null;
  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="返回顶部"
      className="fixed bottom-6 right-5 z-40 flex h-11 w-11 items-center justify-center rounded-md bg-primary-500 text-lg text-background-50 shadow-soft transition-colors hover:bg-primary-600 md:bottom-8 md:right-8"
    >
      <i className="ri-arrow-up-line"></i>
    </button>
  );
}

export default function Home() {
  return (
    <main className="min-h-screen overflow-x-hidden bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(pageLd) }}
      />
      <Navbar />
      <Hero />
      <EraArchive />
      <Featured />
      <RarePicks />
      <Story />
      <Faq />
      <About />
      <Contribute />
      <Footer />
      <BackToTop />
    </main>
  );
}